/* eslint-disable jsx-a11y/alt-text */
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	Collapse,
	Grid,
	IconButton,
	List,
	makeStyles,
	ListItemText,
	Typography,
} from "@material-ui/core";
import StarBorder from "@material-ui/icons/StarBorder";

import { AiFillFacebook, AiFillHome } from "react-icons/ai";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import SendIcon from "@material-ui/icons/Send";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import {useHistory} from "react-router"
import { MdExpandMore } from "react-icons/md";
import React, { useState } from "react";

const useStyle = makeStyles((theme) => ({
	root : {
		paddingTop : theme.spacing(3)
	},
	frAvt : {
		borderRadius: "50%",
		width : 100,
		height : 100,
		overflow : "hidden",
		padding : theme.spacing(1)
	},
	avt: {
		borderRadius: "50%",
		width : "100%"
	},
	name: {
		padding: 10,
		fontWeight : 550,
		color : theme.palette.secondary.main
	},
	accordion: {
		background: theme.palette.background.default,
		boxShadow: "none",
	},
	accordionActive: {
		boxShadow: "none",
		background: theme.palette.background.paper,
	},
	iconLink: {
		paddingRight: 5,
	},
	accordionDetail: {
		background: theme.palette.background.default,
	},
}));
export default function NavBar() {
	const [collapse, setCollapse] = useState({
		collapse1 : false
	})
	const history = useHistory();
	const classes = useStyle();
	return (
		<Grid container justify = "center" className = {classes.root}>
			<Grid container justify="center" className = {classes.frAvt} >
				<img
					className={classes.avt}
					src="https://scontent.fsgn2-6.fna.fbcdn.net/v/t1.6435-9/118597903_1228628764170511_1465522822720747002_n.jpg?_nc_cat=110&ccb=1-3&_nc_sid=09cbfe&_nc_ohc=E2gVxs537C8AX_2IYxf&_nc_ht=scontent.fsgn2-6.fna&oh=8725c173317f55be4972d46519e8dddc&oe=60A797F9"
				/>
			</Grid>
			<Grid container  justify="center">
				<Typography className={classes.name} align="center" variant="h5">
					Van Luong
				</Typography>
			</Grid>
			<Grid container justify="space-evenly">
				<IconButton
					onClick = {()=> window.location.href = "https://www.facebook.com/luong.lgnvpr/"}
				>
					<AiFillFacebook color="white" />
				</IconButton>
				<IconButton onClick = {()=> window.location.href = "https://www.facebook.com/luong.lgnvpr/"}>
					<AiFillFacebook color="white" />
				</IconButton>
				<IconButton onClick = {()=> window.location.href = "https://www.facebook.com/luong.lgnvpr/"}>
					<AiFillFacebook color="white" />
				</IconButton>
			</Grid>
			<Grid>
				<List component="nav" aria-labelledby="nested-list-subheader">
					{/* <ListItem button>
						<ListItemIcon>
							<SendIcon />
						</ListItemIcon>
						<ListItemText primary="Table" />
					</ListItem> */}
					<ListItem 
					style ={{
						cursor : "pointer"
					}}
					onClick={()=>{
						setCollapse({
							...collapse,
							collapse1 : !collapse.collapse1
						})
					}}>
						<ListItemIcon>
							<InboxIcon />
						</ListItemIcon>
						<ListItemText primary="Gen code" />
						{collapse.collapse1 ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={collapse.collapse1} timeout="auto" unmountOnExit >
						<List component="div" disablePadding style ={{
							paddingLeft : 10,
						}}>
							<ListItem button onClick = {(e)=>{
								history.push("/setting-table")
							}}>
								<ListItemIcon>
									<StarBorder />
								</ListItemIcon>
								<ListItemText primary="Setting Table" />
							</ListItem>
							<ListItem button  onClick = {(e)=>{
								history.push("/setting-template")
							}}>
								<ListItemIcon>
									<StarBorder />
								</ListItemIcon>
								<ListItemText primary="Template" />
							</ListItem>
						</List>
					</Collapse>
				</List>
			</Grid>
		</Grid>
	);
}
